<template>
  <div class="footer">
    <div class="content">
      <div class="info-content">
        <a-row>
          <a-col :span="5">
            <complete-logo />
          </a-col>
          <a-col :span="4">
            <div class="grid-title">用户指南</div>
            <ul class="grid__list">
              <li>
                <a class="color-grey" target="_blank" href="/helps/category/1"
                  >帮助中心</a
                >
              </li>
              <li>
                <a class="color-grey" target="_blank" href="/helps/category/1"
                  >如何做家教</a
                >
              </li>
              <li>
                <a class="color-grey" target="_blank" href="/helps/category/1"
                  >如何请家教</a
                >
              </li>
            </ul>
          </a-col>
          <a-col :span="4">
            <div class="grid-title">服务条款</div>
            <ul class="grid__list">
              <li>
                <a class="color-grey" target="_blank" href="/article/info/11"
                  >用户服务协议</a
                >
              </li>
              <li>
                <a class="color-grey" target="_blank" href="/article/info/12"
                  >教员服务协议</a
                >
              </li>
              <li>
                <a class="color-grey" target="_blank" href="/article/info/7"
                  >法律声明和隐私政策</a
                >
              </li>
            </ul>
          </a-col>
          <a-col :span="6">
            <div class="grid-title">关于我们</div>
            <ul class="grid__list">
              <li>
                <a class="color-grey" target="_blank" href="/article/info/9"
                  >小橙家教简介</a
                >
              </li>
              <li>
                <a class="color-grey" target="_blank" href="/article/info/10"
                  >小橙家教宗旨</a
                >
              </li>
              <li>邮箱：admin@orangemust.com</li>
            </ul>
          </a-col>
          <a-col :span="5">
            <div class="grid-title">关注我们</div>
            <img
              class="show-img"
              src="@/assets/wx-public.png"
              alt="微信公众号"
            />
          </a-col>
        </a-row>
      </div>
      <div class="recode-content">
        © 2020－2026 小橙家教 <a target="_blank" href="https://beian.miit.gov.cn/">蜀ICP备2022026614号</a>
      </div>
    </div>
  </div>
</template>

<script>
import { CompleteLogo } from '@/components'

export default {
  name: 'MainFooter',
  components: {
    CompleteLogo
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="stylus" scoped>
.footer {
  width: 100%;
  height: 368px;
  background-color: #333333;

  .content {
    max-width: $container-width;
    height: 100%;
    margin: auto;
    line-height: 40px;
    padding-left: 10px;
    padding-right: 10px;
    color: #fff;

    .info-content {
      height: 292px;
      padding-top: 60px;
      text-align: left;

      .grid-title {
        font-family: MicrosoftYaHei;
        font-size: 16px;
        font-weight: normal;
        font-stretch: normal;
        line-height: 32px;
        letter-spacing: 0px;
        color: #ffffff;
        padding-bottom: 20px;
      }

      .grid__list {
        list-style: none;
        padding: 0px;
        margin: 0px;

        .grid-item, a {
          color: #fff;
        }
      }

      .show-img {
        width: 100px;
        height: 100px;
        border-radius: 5px; /* 10px,图片边缘要大一点*/
      }
    }

    .recode-content {
      width: 100%;
      height: 75px;
      margin: auto;
      line-height: 75px;
      border-top: 1px solid #3f3f3f;

      a {
        color: #fff;
        text-decoration: underline;
      }
    }
  }
}
</style>
